import DoctorHomePage from '../pages/doctor/home'
import DoctorDashboardPage from '../pages/doctor/dashboard'
import DoctorAppointmentsPage from '../pages/doctor/appointments'
import DoctorInstantAppointmentsPage from '../pages/doctor/appointments/instants'
import DoctorRequestAppointmentsPage from '../pages/doctor/appointments/requests'
import DoctorAppointmentDetailsPage from '../pages/doctor/appointments/details'
import DoctorChatsPage from '../pages/doctor/chats'
import DoctorCallPage from '../pages/doctor/call'
import DoctorPatientsPage from '../pages/doctor/patients'
import DoctorProfileDetailsPage from '../pages/doctor/profile/details'
import DoctorProfileEditPage from '../pages/doctor/profile/edit'
import DoctorDocumentsPage from '../pages/doctor/documents'
import DoctorAvailabilitiesPage from '../pages/doctor/availabilities'
import DoctorChangePasswordPage from '../pages/doctor/changePassword'
import DoctorTalkToSupportPage from '../pages/doctor/talkToSupport'
import DoctorTransactionsPage from '../pages/doctor/transactions'
const routes = [
  {
    Component: DoctorHomePage,
    exact: true,
    index: true,
  },
  {
    Component: DoctorDashboardPage,
    exact: true,
    path: 'dashboard',
  },
  {
    Component: DoctorAppointmentsPage,
    exact: true,
    path: 'appointments',
  },
  {
    Component: DoctorInstantAppointmentsPage,
    exact: true,
    path: 'appointments/instants',
  },
  {
    Component: DoctorRequestAppointmentsPage,
    exact: true,
    path: 'appointments/requests',
  },
  {
    Component: DoctorAppointmentDetailsPage,
    exact: true,
    path: 'appointments/:slug',
  },
  {
    Component: DoctorPatientsPage,
    exact: true,
    path: 'patients',
  },
  {
    Component: DoctorChatsPage,
    exact: true,
    path: 'chats',
  },
  {
    Component: DoctorCallPage,
    exact: true,
    path: 'call',
  },
  {
    Component: DoctorProfileDetailsPage,
    exact: true,
    path: 'profile',
  },
  {
    Component: DoctorProfileEditPage,
    exact: true,
    path: 'profile/edit',
  },
  {
    Component: DoctorAvailabilitiesPage,
    exact: true,
    path: 'availabilities',
  },
  {
    Component: DoctorDocumentsPage,
    exact: true,
    path: 'documents',
  },
  {
    Component: DoctorChangePasswordPage,
    exact: true,
    path: 'change-password',
  },
  {
    Component: DoctorTalkToSupportPage,
    exact: true,
    path: 'talk-to-support',
  },
  {
    Component: DoctorTransactionsPage,
    exact: true,
    path: 'transactions',
  },
]

export default routes
